export const ZOOM_AMOUNT = 0.1
export const MAX_ZOOM = 2

// clamps 2 digit decimal between ZOOM_AMOUNT and MAX_ZOOM
export const getNormalizedZoom = (zoom: number): number => {
  const normalizedZoom = parseFloat(zoom.toFixed(2))
  const clampedZoom = Math.max(ZOOM_AMOUNT, Math.min(normalizedZoom, MAX_ZOOM))
  return clampedZoom
}
